export const convertToJson = data => JSON.stringify(data, null, 2);
